export const UPDATE_TIMESHEET_MODEL_NZ = "UPDATE_TIMESHEET_MODEL_NZ";
export const UPDATE_TIMESHEET_LOADING_NZ = "UPDATE_TIMESHEET_LOADING_NZ";
export const UPDATE_EMPLOYEE_TIMESHEET_STATUS_NZ = "UPDATE_EMPLOYEE_TIMESHEET_STATUS_NZ";
export const SELECT_TIMESHEET_NZ = "SELECT_TIMESHEET_NZ";
export const SELECT_TIMESHEET_ROW_NZ = "SELECT_TIMESHEET_ROW_NZ";
export const SELECT_TIMESHEET_ALL_NZ = "SELECT_TIMESHEET_ALL_NZ";
export const REMOVE_TIMESHEET_ENTRY_NZ = "REMOVE_TIMESHEET_ENTRY_NZ";
